export default function controlledPromise() {
  let captured;
  const promise = new Promise((resolve, reject) => captured = {
    resolve,
    reject
  }); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  return {
    promise,
    ...captured
  };
}